import React from 'react';
import PropTypes from 'prop-types';

import SpecialtyAlbumGreeting from './SpecialtyAlbumGreeting';
import withModal from '../../../../../../components/global/modal/withModal';

export const SPECIALTY_ALBUM_GREETING_MODAL = 'modal/SPECIALTY_ALBUM_GREETING';

const propTypes = {
  actionProps: PropTypes.shape({
    albumId: PropTypes.string,
    headerless: PropTypes.bool,
    onAddPhotos: PropTypes.func,
    dismissible: PropTypes.bool,
  }),
};

const SpecialtyAlbumGreetingModal = ({ actionProps, ...props }) => {
  return (
    <div className="px-md-4 pb-md-4">
      <SpecialtyAlbumGreeting
        albumId={actionProps?.albumId}
        headerless={actionProps?.headerless}
        onAddPhotos={actionProps?.onAddPhotos}
        dismissible={actionProps?.dismissible}
        {...props}
      />
    </div>
  );
};

SpecialtyAlbumGreetingModal.propTypes = propTypes;

export default withModal(SpecialtyAlbumGreetingModal, {
  size: 'md',
  type: 'full',
  name: SPECIALTY_ALBUM_GREETING_MODAL,
  className: 'specialty-album-modal',
});
